import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loadding from "../../components/common/loadding";
import CreateCourse from "../../components/curriculum/curriculumDetail/createCourse/createCourse";
import DeleteCourse from "../../components/curriculum/curriculumDetail/createCourse/deleteCourse";
import EditCourse from "../../components/curriculum/curriculumDetail/createCourse/editCourse";
import courseService from "../../services/course.service";
import curriculumService from "../../services/curriculum.service";

const courseContext = React.createContext({});
type ParamType = {
  id: string;
};
const CurriDetail = () => {
  const Param = useParams<ParamType>();
  const [course, setCourse] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [curri, setCurri] = useState<any>();
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      await curriculumService.getById(Number(Param.id)).then((curri) => {
        setCurri(curri.data);
        courseService.getCourseByID(Number(Param.id)).then((res: any) => {
          setCourse(res.data);
          setCourseList(res.data);
          setStatus(false);
        });
      });
    })();
  }, [Param.id]);

  // const handleSearch = (event: any) => {
  //   setCourseList(
  //     course.filter(
  //       (item: any) =>
  //         item.courseCode.includes(event.target.value) ||
  //         item.name.includes(event.target.value) ||
  //         item.category.includes(event.target.value)
  //     )
  //   );
  // };
  if (status) {
    return <Loadding />;
  }

  return (
    <courseContext.Provider
      value={{ courseList, setCourseList, course, setCourse, curri }}
    >
      <div className="container">
        <h3 className="text-start mt-3">จัดการหลักสูตร</h3>
        <div className="row mt-3">
          <div className="col text-start">
            <div className="p-3 pt-4 mb-4 alert alert-primary">
              <h4>
                ชื่อหลักสูตร {`  ${curri?.name}`} (ชื่อย่อ
                {` ${curri?.shortName}`})
              </h4>
              <p>หน่วยงานรับผิดชอบ {curri?.department}</p>
              <p>ระดับ {curri?.level}</p>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <h4 className="text-start">ประกอบด้วยรายวิชา</h4>
            <h3 className="p-3 mb-4 bg-light rounded-4">
              <div className="row">
                <div className="col">
                  {/* <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหารายวิชา"
                    aria-label="ค้นหารายวิชา"
                    onChange={handleSearch}
                  /> */}
                </div>

                <div className="col-2 d-grid">
                  <CreateCourse />
                </div>
              </div>
            </h3>
            <table className="table table-hover table-responsive">
              <thead className="table-dark">
                <tr>
                  <th scope="col">รหัสวิชา</th>
                  <th scope="col">ชื่อวิชา</th>
                  <th scope="col">หน่วยกิต</th>
                  <th scope="col">หมวด</th>
                  <th scope="col">Handle</th>
                </tr>
              </thead>
              <tbody>
                {courseList.length > 0 &&
                  courseList.map((c: any) => {
                    // console.log(c);

                    return (
                      <tr key={c.id}>
                        <td>{c.courseCode}</td>
                        <td className="text-start">{c.name}</td>
                        <td>{c.cradit}</td>
                        <td>{c.category?.name}</td>
                        <td>
                          <EditCourse course={c} />
                          <DeleteCourse course={c} />
                        </td>
                      </tr>
                    );
                  })}
                {!(courseList.length > 0) && (
                  <tr>
                    <td colSpan={5}>
                      <i className="bi bi-folder-x"></i> ไม่พบข้อมูล
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </courseContext.Provider>
  );
};
export { courseContext };
export default CurriDetail;
